import React, { memo } from 'react'

// "isActive" -> "Active", "isPremium" -> "Premium"
const toggleLabel = (name) => `Toggle ${name ? name.replace(/^is/, '') : 'value'}`

// Rendered once per table row — memoized so unrelated row re-renders skip it.
export const Switch = memo(({ id, name, checked, onChange, disabled = false }) => {
    return (
        <label className="switch">
            <input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} disabled={disabled} aria-label={toggleLabel(name)} />
            <span className="inline slider"></span>
        </label>
    )
})

Switch.displayName = 'Switch'

export default Switch